module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Mark Burnell\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("MARK BURNELL was born in Northumberland, England, and grew up in Brazil. He is a novelist and screenwriter. His debut novel, "), _c('I', [_vm._v("The Rhythm Section")]), _vm._v(", the first in a series of thrillers featuring Stephanie Patrick, is the basis for a major motion picture. Burnell lives in London with his family.")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/BK4xb/tc-custom/9781250210579.jpg?1740686336219",
      "alt": "This image is the cover for the book Rhythm Section, Stephanie Patrick Thrillers"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Rhythm Section, Stephanie Patrick Thrillers\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("An innocent woman goes deep undercover to hunt down those responsible for her family’s death in this international thriller—now a major motion picture.")]), _c('br'), _c('br'), _vm._v("Stephanie Patrick is devastated after her whole family dies in a plane crash. But when she discovers that the downing of flight NE027 wasn’t an accident but an act of terrorism, Stephanie enters the fight of her life to achieve her one goal: revenge."), _c('br'), _c('br'), _vm._v("When she’s recruited by a covert intelligence organization, Stephanie sees a means to an end. With nothing left to lose, she undergoes rigorous training to become “Petra,” a mercenary terrorist based out of Germany, and “Marina,” an international businesswoman based in London. Her immersion into the world of international espionage teaches Stephanie how to numb her feelings and act on instinct alone. But as the stakes and brutality escalate, she begins to question everything she knows about flight NEO027."), _c('br'), _c('br'), _vm._v("Is Stephanie’s organization telling her the truth about what happened? Is avenging her family worth the risk of her own life? And if it isn’t, will those who created her ever let her go?\n    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    St. Martin’s Press\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0